import React from 'react';
import { FullscreenCarousel } from '@cian/frontend-fullscreen-carousel-component';
import { IImages, INewbuildingSummaryCellValue } from '../../types/newbuildingsCompare';
import { prepareSlides } from './slides';
import { getFullscreenOptions } from './options';

export interface IMobileGalleryContainerProps {
  images: IImages[];
  onClose(): void;
  newbuilding?: INewbuildingSummaryCellValue;
}

export function MobileGalleryContainer({ images, onClose, newbuilding }: IMobileGalleryContainerProps) {
  const slides = prepareSlides(images);

  return <FullscreenCarousel slides={slides} media={getFullscreenOptions(newbuilding)} onClose={onClose} />;
}
